/******************************************************************************************
 *	Customers Response Transformer
 *******************************************************************************************
 *
 *
 *
 */
(function() {
  

  angular.module('rcServices.customersResponseTransformer', []).service(
    'CustomersResponseTransformer',
    /* @ngInject */
    function(_, DefaultResponseTransformer) {
      var transformer = function(responseData, headers) {
        let data = DefaultResponseTransformer.processData(responseData, headers);

        return data;
      };
      return transformer;
    }
  );
})();
